export const breakpoints = [
    '36em',
    '48em',
    '62em',
    '75em',
    '87.5em', // 1400px
];
({
    0: breakpoints.s,
    1: breakpoints.m,
    2: breakpoints.l,
    3: breakpoints.xl,
    4: breakpoints.xxl,
} = breakpoints);
export const mediaQueries = {
    small: `@media screen and (min-width: ${breakpoints[0]})`,
    medium: `@media screen and (min-width: ${breakpoints[1]})`,
    large: `@media screen and (min-width: ${breakpoints[2]})`,
    xLarge: `@media screen and (min-width: ${breakpoints[3]})`,
    xxLarge: `@media screen and (min-width: ${breakpoints[4]})`,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJlYWtwb2ludHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvYnJlYWtwb2ludHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFvQjtJQUMxQyxNQUFNO0lBQ04sTUFBTTtJQUNOLE1BQU07SUFDTixNQUFNO0lBQ04sUUFBUSxFQUFFLFNBQVM7Q0FDcEIsQ0FBQztBQUVGLENBQUM7SUFDQyxDQUFDLEVBQUUsV0FBVyxDQUFDLENBQUM7SUFDaEIsQ0FBQyxFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQ2hCLENBQUMsRUFBRSxXQUFXLENBQUMsQ0FBQztJQUNoQixDQUFDLEVBQUUsV0FBVyxDQUFDLEVBQUU7SUFDakIsQ0FBQyxFQUFFLFdBQVcsQ0FBQyxHQUFHO0NBQ25CLEdBQUcsV0FBVyxDQUFDLENBQUM7QUFFakIsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFxQjtJQUM1QyxLQUFLLEVBQUUsaUNBQWlDLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRztJQUN6RCxNQUFNLEVBQUUsaUNBQWlDLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRztJQUMxRCxLQUFLLEVBQUUsaUNBQWlDLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRztJQUN6RCxNQUFNLEVBQUUsaUNBQWlDLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRztJQUMxRCxPQUFPLEVBQUUsaUNBQWlDLFdBQVcsQ0FBQyxDQUFDLENBQUMsR0FBRztDQUM1RCxDQUFDIn0=